import React, { useEffect, useRef, useState } from "react";

import { HeaderComp } from "components";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import { Check } from "@mui/icons-material";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { db, useClickArea, useIsMounted } from "hooks";
import { useAppContext } from "contexts";
import { auth, database } from "configs/firebaseConfigs";
import { signOut } from "firebase/auth";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterMoment";
import { useFormik } from "formik";
import * as yup from "yup";
import { useProducts } from "hooks/useDataFetch";
import { getArrFromObj } from "@ashirbad/js-core";
import Swal from "sweetalert2";
import { onValue, ref } from "firebase/database";

const Checkout = () => {
  const [deliveryDate, setDeliveryDate] = useState("");
  const [deliveryTime, setDeliveryTime] = useState([]);
  const [chooseDeliveryTime, setChooseDeliveryTime] = useState({});
  const [checkoutProduct, setCheckoutProduct] = useState([]);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const { user } = useAppContext();
  const [chooseAddress, setChooseAddress] = useState(false);
  const [chooseFromSavedAddress, setChooseFromSavedAddress] = useState(false);
  const [allAddress, setAllAddress] = useState([]);
  const [payOnDelivery, setPayOnDelivery] = useState(false);
  const [initialValue, setInitialValue] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    landmark: "",
    country: "",
    postalCode: "",
    deliveryDate: deliveryDate,
    deliveryTime: chooseDeliveryTime,
    addressType: "",
  });

  const [orderedAddress, setOrderedAddress] = useState({});

  // console.log(user?.address);

  const location = useLocation();
  const navigate = useNavigate();

  // console.log(location.state.orderData);

  const [shipping, setShipping] = useState(true);

  const product = useProducts();

  // const [orderComplete, setOrderComplete] = useState(false);
  // const orderRef = useRef();

  const selectAddressRef = useRef();

  // useClickArea(orderRef, () => {
  //   setOrderComplete(false);
  // });
  useClickArea(selectAddressRef, () => {
    setChooseAddress(false);
  });

  const isMounted = useIsMounted();

  useEffect(() => {
    if (isMounted?.current) {
      if (location?.state?.orderData?.deliveryDate) {
        setDeliveryDate(location?.state?.orderData?.deliveryDate);
      }
      if (location?.state?.orderData?.deliveryTime) {
        setChooseDeliveryTime(location?.state?.orderData?.deliveryTime);
      }
    }
  }, [isMounted, location?.state]);

  console.log(location?.state?.orderData);

  // console.log(chooseDeliveryTime);

  useEffect(() => {
    if (isMounted.current) {
      if (user?.uid && user?.address) {
        let address = getArrFromObj(user?.address);
        setAllAddress(address);
      }
    }
  }, [user, isMounted]);
  useEffect(() => {
    if (isMounted.current) {
      if (location.state?.orderData.deliveryDate) {
        setInitialValue((values) => {
          return {
            ...values,
            deliveryDate: location?.state?.orderData?.deliveryDate,
          };
        });
      }
      if (location.state?.orderData.deliveryTime) {
        setInitialValue((values) => {
          return {
            ...values,
            deliveryTime: location?.state?.orderData?.deliveryTime,
          };
        });
      }
    }
  }, [location.state, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (location?.state?.orderData) {
        let checkoutArray = [];
        product?.data?.filter((item) => {
          let productData = location?.state?.orderData?.products?.find(
            (data) => {
              return data.id === item.id;
            }
          );
          if (productData) {
            let newData = {
              ...item,
              cartQuantity: productData.quantity,
            };
            checkoutArray.push(newData);
          }
          return productData;
        });

        setCheckoutProduct(checkoutArray);
      }
    }
  }, [location.state, isMounted, product?.data]);

  useEffect(() => {
    if (isMounted.current) {
      let totalDiscount = checkoutProduct?.reduce(
        (accumulator, currentValue) => {
          return Number(
            (
              accumulator +
              ((currentValue.price * (currentValue.discount || 0)) / 100) *
                currentValue.cartQuantity
            ).toFixed(2)
          );
        },
        0
      );
      setTotalDiscount(totalDiscount);
    }
  }, [checkoutProduct, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      let totalPrice = checkoutProduct?.reduce((accumulator, currentValue) => {
        return Number(
          (
            accumulator +
            currentValue.price * currentValue.cartQuantity
          ).toFixed(2)
        );
      }, 0);
      setTotalPrice(totalPrice);
    }
  }, [checkoutProduct, isMounted]);

  // console.log(checkoutData);

  // console.log(checkoutProduct);

  const logOut = () => {
    signOut(auth)
      .then(() => {
        Navigate("/login");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  useEffect(() => {
    if (isMounted.current) {
      onValue(ref(database, "/config/deliverytime"), (snap) => {
        if (snap.exists()) {
          setDeliveryTime(snap.val());
        }
      });
    }
  }, [isMounted]);

  const validationSchema = yup.object({
    firstName: yup.string().required("First name is required"),
    lastName: yup.string(),
    address: yup.string().required("Address is required"),
    city: yup.string().required("City is required"),
    country: yup.string().required("Country is required"),
    postalCode: yup.string().required("Postal code is required"),
    deliveryDate: yup.string().required("Delivery date is required").nullable(),
    deliveryTime: yup.object().required("Required").nullable(),
    addressType: yup.string().required("Address type is required"),
    landmark: yup.string(),
  });

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      try {
        // console.log(values);
        if (!chooseFromSavedAddress) {
          saveAddress(values);
        }
        setShipping(false);
      } catch (error) {
        console.log(error);
      }
    },
  });

  // console.log(checkoutData);

  const saveAddress = (values) => {
    try {
      const address = {
        firstName: values?.firstName,
        lastName: values?.lastName,
        address: values?.address,
        landmark: values?.landmark,
        city: values?.city,
        country: values?.country,
        postalCode: values?.postalCode,
        addressType: values?.addressType,
        default: false,
        contactNo: user?.phoneNumber,
      };
      // console.log(address);
      setOrderedAddress(address);
      //save address to user database

      db.pushData("users/" + user?.uid + "/address", address)
        .then(() => {
          console.log("address saved");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // console.log(checkoutProduct);

  const handleOrder = async () => {
    try {
      if (!user?.uid) return;
      if (checkoutProduct?.length === 0) return;

      let orderData = {
        products:
          checkoutProduct?.length > 0 &&
          checkoutProduct?.map((item) => {
            return {
              productName: item?.name,
              productId: item?.id,
              orderedQty: item?.cartQuantity,
              price: item?.price,
              productImg: item?.images[0]?.url,
              supplierId: item?.supplierId,
              supplierName: item?.supplierName,
              discount: item?.discount || 0,
            };
          }),

        deliveryDate: formik.values.deliveryDate,
        deliveryTime: formik.values.deliveryTime,
        totalPrice: totalPrice,
        totalDiscount: totalDiscount,
        status: "pending",
        delivered: false,
        deliveredAt: "",
        userId: user?.uid,
        userName: user?.displayName,
        orderDate: new Date().toLocaleDateString(),
        orderTime: new Date().toLocaleTimeString(),
        paymentStatus: "pending",
        paymentMode: payOnDelivery ? "COD" : "Online",
        paymentId: "",
        paymentDate: "",
        paymentAmount: "",
        createdAt: Date.now(),
        updatedAt: Date.now(),
        orderMessage: "Order Placed",
        address: orderedAddress,
      };
      await db.pushData(`orders/${user?.uid}`, orderData);

      //remove cart data
      checkoutProduct?.map(async (item) => {
        await db.delateData(`cart/${user?.uid}/${item?.id}`);
      });
      // console.log(orderData);

      Swal.fire({
        title: "Order Placed",
        text: `Your order has been placed successfully.`,
        icon: "success",
        confirmButtonText: "OK",
      })
        .then(() => {
          navigate("/profile/myorder");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
      });
    }
  };

  return (
    <main className="cart-main">
      <HeaderComp title="Checkout" />
      {/* popup
      {orderComplete && (
        <div className="order-update-main  flex-row align-items-center justify-content-center">
          <div
            className="order-update-main-outer flex-column  align-items-center justify-content-center"
            onKeyDown={() => {
              setOrderComplete(false);
            }}
            ref={orderRef}
          >
            <span className="order-update-icon">
              <CheckCircle />
            </span>
            <span className="order-update-text">
              Thank you for placing your order
            </span>
            <span className="order-update-btn">
              <Link to="/profile/myorder">
                <Button className="order-update-btn-order">
                  Go to My Orders
                </Button>
              </Link>
            </span>
          </div>
        </div>
      )} */}
      {/* popup */}
      {chooseAddress && (
        <div className="order-update-main choose-address-main  flex-row align-items-center justify-content-center">
          <div
            className="order-update-main-outer flex-column  align-items-center justify-content-center"
            onKeyDown={() => {
              setChooseAddress(false);
            }}
            ref={selectAddressRef}
          >
            <span
              style={{
                paddingBottom: "1rem",
                color: "#ffffff",
                fontSize: "1.5rem",
              }}
            >
              Select your delivery address
            </span>
            <div className="flex-column choose-address-outer profile-all-saved-address  ">
              {allAddress?.length > 0 &&
                allAddress?.map((item, index) => {
                  return (
                    <div
                      className="saved-address-card flex-column  "
                      key={index}
                      onClick={() => {
                        setInitialValue((values) => {
                          return {
                            ...values,
                            firstName: item?.firstName,
                            lastName: item?.lastName,
                            address: item?.address,
                            landmark: item?.landmark,
                            city: item?.city,
                            country: item?.country,
                            postalCode: item?.postalCode,
                            addressType: item?.addressType,
                          };
                        });
                        setOrderedAddress(item);
                        setChooseFromSavedAddress(true);
                        setChooseAddress(false);
                      }}
                    >
                      <div className="checkout-address-type">
                        <span className="checkout-address-type-span">
                          {item?.addressType}
                        </span>
                      </div>
                      <div className="profile-saves-address-name flex-row align-items-center gap-2 ">
                        <span>{item?.firstName}</span>
                        {/* <span>{user phone number}</span> */}
                      </div>
                      <div className="profile-saved-address-details flex-row align-items-center gap-1 flex-wrap">
                        <span>{item?.address}</span>
                        <span>{item?.landmark}</span>
                        <span> {item?.city} </span>
                        <span> {item?.country} </span>
                        <span>{item?.postalCode}</span>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}

      {/* popup finished */}
      <Container>
        <Grid container className="cart-main-container gap-2">
          <Grid item xs={12} sm={12} md={7.5}>
            <div className=" shopping-cart-left flex-column gap-2">
              <section className="shipping-cart-login-section">
                <div className="cart-left-accordion-main">
                  <div className="shopping-cart-login-details flex-row  align-items-center justify-content-between w-100">
                    <div className="shopping-cart-login-details-left flex-column gap-1 ">
                      <span className="flex-row align-items-center gap-2">
                        LOGIN <Check />{" "}
                      </span>

                      <span className="user-login-details flex-row align-items-center gap-2 ">
                        <span className="user-login-details-name">
                          {user?.displayName}
                        </span>
                        <span className="user-login-details-number">
                          {user?.phoneNumber}
                        </span>
                      </span>
                    </div>
                    <div className="shopping-cart-login-details-right">
                      <Button
                        className="shopping-cart-login-change-btn"
                        onClick={logOut}
                      >
                        Change
                      </Button>
                    </div>
                  </div>
                </div>
              </section>
              <section className="">
                <Accordion
                  className="cart-left-accordion-main"
                  // expanded={expanded === "panel2"}
                  // onChange={() => {
                  //   setShipping(!shipping);
                  // }}
                  expanded={shipping}
                >
                  <AccordionSummary
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <div className="flex-row align-items-center justify-content-between w-100">
                      <h3
                        className="cart-shipping-address-section-title"
                        onClick={() => {
                          setShipping(!shipping);
                        }}
                      >
                        Shipping Address
                      </h3>

                      <Button
                        className="cart-shipping-address-section-btn"
                        onClick={() => {
                          allAddress?.length > 0
                            ? setChooseAddress(true)
                            : Swal.fire({
                                icon: "info",
                                title: "No saved address found",
                              });
                        }}
                      >
                        Choose Address
                      </Button>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <form onSubmit={formik.handleSubmit}>
                      <div className="cart-shipping-address-main-container flex-column gap-2 ">
                        <div className="cart-shipping-address-name flex-row align-items-center gap-2 ">
                          <span className="cart-shipping-address-first-name w-100  shopping-cart-input ">
                            <InputLabel>First Name *</InputLabel>

                            <TextField
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              name="firstName"
                              value={formik.values.firstName}
                              error={
                                formik.touched.firstName &&
                                formik.errors.firstName
                                  ? true
                                  : false
                              }
                              helperText={
                                formik.touched.firstName &&
                                formik.errors.firstName
                                  ? formik.errors.firstName
                                  : ""
                              }
                            />
                          </span>
                          <span className="cart-shipping-address-last-name w-100  shopping-cart-input ">
                            <InputLabel>Last Name *</InputLabel>

                            <TextField
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              name="lastName"
                              value={formik.values.lastName}
                              error={
                                formik.touched.lastName &&
                                formik.errors.lastName
                                  ? true
                                  : false
                              }
                              helperText={
                                formik.touched.lastName &&
                                formik.errors.lastName
                                  ? formik.errors.lastName
                                  : ""
                              }
                            />
                          </span>
                        </div>
                        <div className="cart-shipping-address-address flex-row align-items-center gap-2 ">
                          <span className="cart-shipping-address-locality   shopping-cart-input ">
                            <InputLabel>Address *</InputLabel>

                            <TextField
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              name="address"
                              value={formik.values.address}
                              error={
                                formik.touched.address && formik.errors.address
                                  ? true
                                  : false
                              }
                              helperText={
                                formik.touched.address && formik.errors.address
                                  ? formik.errors.address
                                  : ""
                              }
                            />
                          </span>
                          <span className="cart-shipping-address-street   shopping-cart-input ">
                            <InputLabel>Street/Landmark</InputLabel>

                            <TextField
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              name="landmark"
                              value={formik.values.landmark}
                              error={
                                formik.touched.landmark &&
                                formik.errors.landmark
                                  ? true
                                  : false
                              }
                              helperText={
                                formik.touched.landmark &&
                                formik.errors.landmark
                                  ? formik.errors.landmark
                                  : ""
                              }
                            />
                          </span>
                        </div>
                        <div className="cart-shipping-address-country flex-row align-items-center gap-2 ">
                          <span className="cart-shipping-address-city w-100  shopping-cart-input ">
                            <InputLabel>City *</InputLabel>

                            <TextField
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              name="city"
                              value={formik.values.city}
                              error={
                                formik.touched.city && formik.errors.city
                                  ? true
                                  : false
                              }
                              helperText={
                                formik.touched.city && formik.errors.city
                                  ? formik.errors.city
                                  : ""
                              }
                            />
                          </span>
                          <span className="cart-shipping-address-street w-100  shopping-cart-input ">
                            <InputLabel>Country *</InputLabel>

                            <TextField
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              name="country"
                              value={formik.values.country}
                              error={
                                formik.touched.country && formik.errors.country
                                  ? true
                                  : false
                              }
                              helperText={
                                formik.touched.country && formik.errors.country
                                  ? formik.errors.country
                                  : ""
                              }
                            />
                          </span>
                        </div>
                        <div className="flex-row align-items-start gap-2 postal-time ">
                          <div className="cart-shipping-postal-code flex-column    shopping-cart-input ">
                            <InputLabel>Postal Code *</InputLabel>

                            <TextField
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              name="postalCode"
                              value={formik.values.postalCode}
                              error={
                                formik.touched.postalCode &&
                                formik.errors.postalCode
                                  ? true
                                  : false
                              }
                              helperText={
                                formik.touched.postalCode &&
                                formik.errors.postalCode
                                  ? formik.errors.postalCode
                                  : ""
                              }
                            />
                          </div>
                          <div className="cart-shipping-postal-code flex-column  ">
                            <InputLabel className="shopping-cart-input-label">
                              Select Date and Time *
                            </InputLabel>

                            <div className="delivery-time-select flex-row align-items-start gap-1 ">
                              <div className="product-select-delivery-date w-100">
                                <LocalizationProvider dateAdapter={DateAdapter}>
                                  <DatePicker
                                    label="Select Delivery Date"
                                    value={deliveryDate}
                                    disablePast
                                    onChange={(newValue) => {
                                      setDeliveryDate(
                                        moment(newValue).format("YYYY-MM-DD")
                                      );
                                      formik.setFieldValue(
                                        "deliveryDate",
                                        moment(newValue).format("YYYY-MM-DD")
                                      );
                                    }}
                                    toolbarPlaceholder="Select Delivery  Date"
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        onBlur={formik.handleBlur}
                                        name="deliveryDate"
                                        value={formik.values.deliveryDate}
                                        error={
                                          formik.touched.deliveryDate &&
                                          formik.errors.deliveryDate
                                            ? true
                                            : false
                                        }
                                        helperText={
                                          formik.touched.deliveryDate &&
                                          formik.errors.deliveryDate
                                            ? formik.errors.deliveryDate
                                            : ""
                                        }
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </div>
                              <div className="delivery-time-picker w-100 ">
                                <Select
                                  fullWidth
                                  className="product-select-delivery-time"
                                  value={chooseDeliveryTime}
                                  onChange={(e) => {
                                    setChooseDeliveryTime(e.target.value);
                                    formik.setFieldValue(
                                      "deliveryTime",
                                      e.target.value
                                    );
                                  }}
                                  error={
                                    formik.touched.deliveryTime &&
                                    formik.errors.deliveryTime
                                      ? true
                                      : false
                                  }
                                >
                                  {deliveryTime?.map((time, index) => {
                                    return (
                                      <MenuItem value={time} key={index}>
                                        {" "}
                                        {time.startTime} - {time.endTime}{" "}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                                <span className="error-message">
                                  {formik.touched.deliveryTime &&
                                  formik.errors.deliveryTime
                                    ? formik.errors.deliveryTime
                                    : ""}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="cart-shipping-address-type flex-column    shopping-cart-input ">
                          <InputLabel>Address Type *</InputLabel>

                          <RadioGroup
                            row
                            className="flex-row gap-2   "
                            defaultValue={""}
                            name="addressType"
                            value={formik.values.addressType}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          >
                            <span className="address-type-home  shopping-cart-input ">
                              <FormControlLabel
                                value="home"
                                control={<Radio />}
                                label="Home ( All Day Delivery )"
                              />
                            </span>
                            <span className="address-type-office">
                              <FormControlLabel
                                value="office"
                                control={<Radio />}
                                label="Office ( Delivery Between 9:00 AM - 5:00 PM )"
                              />
                            </span>
                          </RadioGroup>
                          <span className="error-message">
                            {formik.touched.addressType &&
                            formik.errors.addressType
                              ? formik.errors.addressType
                              : ""}
                          </span>
                        </div>

                        <div className="save-cart-address flex-row gap-2 align-items-center ">
                          <Button
                            className="save-cart-address-btn-save"
                            type="submit"
                          >
                            Save And Deliver Here
                          </Button>
                          <Button
                            className="save-cart-address-btn-cancel"
                            onClick={() => {
                              window.history.back();
                            }}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </form>
                  </AccordionDetails>
                </Accordion>
              </section>

              <section className="">
                <Accordion
                  className="cart-left-accordion-main"
                  // onChange={() => {
                  //   setShipping(!shipping);
                  // }}
                  expanded={!shipping}
                >
                  <AccordionSummary
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                  >
                    <h3
                      className="cart-shipping-payment-method"
                      onClick={() => {
                        setShipping(!shipping);
                      }}
                    >
                      Payment Method
                    </h3>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="shipping-cart-payments-method">
                      <div className="pay-on-delivery-option flex-row align-items-center">
                        <Checkbox
                          onClick={(e) => {
                            setPayOnDelivery(e.target.checked);
                          }}
                        />{" "}
                        Pay on Delivery
                      </div>
                      {/* <div className="or flex-row gap-1 align-items-center">
                        Or
                        <hr className="w-100" />
                      </div>
                      <div className="cart-payments-popular-card flex-row align-items-center gap-2 ">
                        <span className="popular-card-items flex-row align-items-center ">
                          <img src={VisaIcon} alt="" />
                        </span>
                        <span className="popular-card-items flex-row align-items-center ">
                          <img src={MaestroIcon} alt="" />
                        </span>
                        <span className="popular-card-items flex-row align-items-center ">
                          <img src={AmericanExIcon} alt="" />
                        </span>
                      </div>
                      <div className="shipping-cart-payments-card-details">
                        <div className="flex-row align-items-center justify-content-between">
                          <div className="card-details-child card-number">
                            <InputLabel>Card Number *</InputLabel>
                            <TextField />
                          </div>
                          <div className="card-details-child card-valid-date">
                            <InputLabel>Valid Thru *</InputLabel>
                            <TextField />
                          </div>
                        </div>
                        <div className="flex-row align-items-center justify-content-between">
                          <div className="card-details-child card-cvv">
                            <InputLabel>CVV *</InputLabel>
                            <TextField />
                          </div>
                          <div className="card-details-child card-holder-name">
                            <InputLabel>Card Holder Name *</InputLabel>
                            <TextField />
                          </div>
                        </div>
                      </div>
                      <div className="save-card flex-row align-items-center">
                        <Checkbox defaultChecked /> Save my details for future
                        use !
                      </div>
                      <div className="card-payment-btn">
                        <Button className="card-payment-btn-save">
                          Save Card
                        </Button>
                      </div> */}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </section>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <div className="shopping-cart-right">
              <div className="shopping-cart-right-header flex-row align-items-center justify-content-center">
                <h3>Your Orders</h3>
              </div>

              <div className="shopping-cart-added-items">
                {checkoutProduct?.length > 0 &&
                  checkoutProduct?.map((item) => {
                    return (
                      <div
                        className="shopping-cart-added-items-child flex-row  gap-2"
                        key={item?.id}
                      >
                        <div className="shopping-cart-added-items-child-left">
                          <img src={item?.images[0]?.url} alt="" />
                        </div>
                        <div className="shopping-cart-added-items-child-right flex-column justify-content-between">
                          <div className="cart-item-product-title">
                            {item?.name}
                          </div>

                          <div className="cart-item-product-details flex-row align-items-center gap-1">
                            <span className="cart-product-type flex-row align-items-center ">
                              Quantity : <p> {item?.waterQuantity} </p>
                            </span>

                            <span className="cart-product-supplier-name flex-row align-items-center ">
                              By : <p> {item?.supplierName} </p>
                            </span>
                          </div>

                          <div className="cart-product-pricing-details flex-row align-items-center gap-1 ">
                            <span className="cart-product-price">
                              SAR {item?.price}
                            </span>
                            x
                            <span className="cart-item-total-product-count">
                              {item?.cartQuantity}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                <div className="cart-delivery-charges  flex-column  gap-2">
                  <div className="delivery-charge flex-row align-items-center justify-content-between ">
                    <h3>Delivery</h3>

                    <span>Free</span>
                  </div>

                  <div className="cart-product-discount flex-row align-items-center justify-content-between">
                    <h3>Discount</h3>
                    <span>SAR {totalDiscount} </span>
                  </div>
                </div>
                <div className="total-cart-value flex-row align-items-center justify-content-between ">
                  <h3 className="total-cart-value-h3">Total</h3>

                  <span>SAR {totalPrice}</span>
                </div>
              </div>
              <div className="shopping-cart-pay-btn">
                <Button
                  className="shopping-cart-pay-btn-save"
                  onClick={() => {
                    handleOrder();
                  }}
                >
                  Order Now
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </main>
  );
};

export default Checkout;
